import { render, staticRenderFns } from "./DocumentPriceChangeCRUD.vue?vue&type=template&id=5819cf23&scoped=true"
import script from "./DocumentPriceChangeCRUD.vue?vue&type=script&lang=js"
export * from "./DocumentPriceChangeCRUD.vue?vue&type=script&lang=js"
import style0 from "./DocumentPriceChangeCRUD.vue?vue&type=style&index=0&id=5819cf23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5819cf23",
  null
  
)

export default component.exports